import * as React from "react"
import {NavLink} from "../navLink";
import {NavDropdown} from "../navDropdown";

export const ManualNavigation = () => {


    return (
        <>
            <NavLink title="操作マニュアルトップ" link="/manual"/>
            <div className="mt-4">
                <NavDropdown name="基本操作"  items={[
                    {title:"共通の基本操作", link:"/manual/basic/basic-operation/"},
                    {title:"一覧画面の基本操作", link:"/manual/basic/basic-operation-list/"},
                    {title:"登録画面の基本操作", link:"/manual/basic/basic-operation-register/"},
                    {title:"明細画面の基本操作", link:"/manual/basic/basic-operation-detail/"},
                    {title:"取込み画面の基本操作", link:"/manual/basic/basic-operation-import/"},
                    {title:"取込用ファイルの編集", link:"/manual/basic/edit-upload-file/"},
                ]}/>
                <NavDropdown name="EC管理（受注取込）"  items={[
                    {title:"EC受注CSV取込", link:"/manual/ec/order-import/"},
                    {title:"makeshopデータ取込", link:"/manual/ec/makeshop/"},
                    {title:"カラーミーデータ取込", link:"/manual/ec/colorme/"},
                    {title:"ショップサーブデータ取込", link:"/manual/ec/shopserve/"},
                    {title:"楽天ペイデータ取込", link:"/manual/ec/rakuten-pay/"},
                    {title:"amazonデータ取込", link:"/manual/ec/amazon/"},
                    {title:"yahooデータ取込", link:"/manual/ec/yahoo/"},
                    {title:"Bcartデータ取込", link:"/manual/ec/bcart/"},
                    {title:"Shopify受注連携", link:"/manual/ec/shopify/"},
                    {title:"フューチャーショップデータ取込", link:"/manual/ec/futureshop/"},
                    {title:"楽々リピート受注連携", link:"/manual/ec/raku2/"},
                ]}/>
         <NavDropdown name="EC管理（取込後の操作）"  items={[
                    {title:"EC受注の流れ", link:"/manual/ec/orderflow/"},
                    {title:"EC直送処理の流れ", link:"/manual/ec/direct/"},
                    {title:"EC受注管理", link:"/manual/ec/order/"},
                    {title:"ECピッキング消込", link:"/manual/ec/picking/"},
                    {title:"送り状No取込", link:"/manual/ec/okurijyo/"},
                    {title:"出荷完了連携", link:"/manual/ec/shipment-completed/"},
                ]}/>
                <NavDropdown name="販売管理"  items={[
                    {title:"販売管理の流れ", link:"/manual/sales/flow/"},
                    {title:"見積", link:"/manual/sales/estimate/"},
                    {title:"見積ワークフロー", link:"/manual/sales/estimate-workflow/"},
                    {title:"受注", link:"/manual/sales/order/"},
                    {title:"受注・発注", link:"/manual/sales/receive-and-order/"},
                    {title:"在庫確保", link:"/manual/sales/allocation/"},
                    {title:"ピッキングリスト", link:"/manual/sales/order-picking-list/"},
                    {title:"売上", link:"/manual/sales/sales/"},
                    {title:"売上予算", link:"/manual/sales/sales-budget/"},
                    {title:"請求・入金", link:"/manual/sales/credit/"},
                    {title:"電子請求書", link:"/manual/sales/electronic-bill/"},

                ]}/>
                <NavDropdown name="購買管理"  items={[
                    {title:"発注", link:"/manual/purchase/ordering/"},
                    {title:"発注ワークフロー", link:"/manual/purchase/ordering-workflow/"},
                    {title:"発注書メール送信", link:"/manual/purchase/ordering-mailsend/"},
                    {title:"発注残", link:"/manual/purchase/ordering-rest/"},
                    {title:"諸掛", link:"/manual/purchase/delivery-charge-divide/"},
                    {title:"仕入", link:"/manual/purchase/delivery/"},
                    {title:"自動発注", link:"/manual/purchase/auto-ordering/"},
                    {title:"買掛・支払", link:"/manual/purchase/payment/"},
                    {title:"発注WebEDI", link:"/manual/purchase/edi/"},
                ]}/>
                <NavDropdown name="在庫管理"  items={[
                    {title:"在庫表", link: "/manual/stock/stock-list/"},
                    {title:"受払明細表", link: "/manual/stock/receipt-payment/"},
                    {title:"受払集計表", link: "/manual/stock/paymentsummary/"},
                    {title:"在庫年齢", link: "/manual/stock/stock-age/"},
                    {title:"セット商品在庫閲覧", link: "/manual/stock/set-item-stock-list/"},
                    {title:"各種在庫数閲覧", link: "/manual/stock/apparel-stock-list/"},
                    {title:"在庫移動", link: "/manual/stock/stock-move/"},
                    {title:"在庫調整", link: "/manual/stock/inventory-adjustment/"},
                    {title:"セット商品組立・解体", link:"/manual/stock/set-item/"},
                    {title:"在庫区分切替", link: "/manual/stock/replace/"},
                    {title:"棚卸", link: "/manual/stock/inventory/"},

                ]}/>
                <NavDropdown name="財務会計"  items={[
                    {title:"仕訳", link:"/manual/finance/journal/"},
                    {title:"月次帳票", link:"/manual/finance/monthly-report/"},
                    {title:"月次推移帳票", link:"/manual/finance/monthly-transition-report/"},

                ]}/>
                <NavDropdown name="締処理"  items={[
                    {title:"請求締処理", link:"/manual/closing/claim-closing/"},
                    {title:"在庫単価算出処理", link:"/manual/closing/stock-price-processing/"},
                    {title:"月次締処理", link:"/manual/closing/monthly/"},
                    {title:"年度繰越", link:"/manual/closing/year-transfer/"},
                ]}/>
                <NavDropdown name="マスタメンテナンス"  items={[
                    {title:"マスタ情報の登録", link:"/manual/master/set-master/"},
                    {title:"マスタ情報の訂正", link:"/manual/master/edit-master/"},
                    {title:"マスタ情報の削除", link:"/manual/master/delete-master/"},
                    {title:"マスタ情報の取込", link:"/manual/master/upload-master/"},
                    {title:"マスタ一覧", link:"/manual/master/all/"},
                    {title:"マスタ検索", link:"/manual/master/search/"},
                ]}/>
                <NavDropdown name="経費精算"  items={[
                    {title:"経費精算ワークフロー設定", link:"/manual/expense/workflow/"},
                    {title:"経費精算登録・申請", link:"/manual/expense/expense/"},
                    {title:"経費精算承認", link:"/manual/expense/expense-approval/"},
                    {title:"支払確定", link:"/manual/expense/fix-payment/"},
                    {title:"経費精算月次締処理", link:"/manual/expense/expense-close-month/"},
                ]}/>
               <NavDropdown name="POS連携"  items={[
                    {title:"スマレジ連携", link:"/manual/pos/sumaregi/"},
                    {title:"Square連携", link:"/manual/pos/square/"},
                ]}/>
               <NavDropdown name="WMSモバイル（オプション）"  items={[
                    {title:"モバイル在庫管理の流れ", link:"/manual/mobile/mobile-flow/"},
                    {title:"モバイル版在庫管理の基本操作", link:"/manual/mobile/mobile-base/"},
                    {title:"在庫照会", link:"/manual/mobile/inventory-inquiry/"},
                    {title:"ピッキング一覧", link:"/manual/mobile/pickinglist/"},
                    {title:"出荷検品", link:"/manual/mobile/delivery-inspection/"},
                    {title:"発注", link:"/manual/mobile/purchase-ordering/"},
                    {title:"仕入消込", link:"/manual/mobile/purchase-reconciliation/"},
                    {title:"仕入消込（仕入先）", link:"/manual/mobile/purchase-reconciliation-supplier/"},
                    {title:"移動出庫", link:"/manual/mobile/warehouse-out/"},
                    {title:"移動出庫検品", link:"/manual/mobile/warehouse-out-inspection/"},
                    {title:"移動入庫", link:"/manual/mobile/warehouse-in/"},
                    {title:"棚卸", link:"/manual/mobile/inventory/"},
                ]}/>
              <NavDropdown name="WMS連携（オプション）"  items={[
                    {title:"ロジザード連携（入荷）", link:"/manual/stock/logizard-receiving/"},
                    {title:"ロジザード連携（出荷）", link:"/manual/stock/logizard-shipping/"},
                ]}/>
               <NavDropdown name="設定"  items={[
                    {title:"利用メニュー設定", link:"/manual/setting/menu/"},
                    {title:"お知らせボード設定", link:"/manual/setting/information/"},
                    {title:"経費精算項目設定", link:"/manual/setting/expense-column/"},
                    {title:"メールテンプレート", link:"/manual/setting/mail-template/"},
                    {title:"ECメールテンプレート", link:"/manual/setting/ec-mail-template/"},
                ]}/>
            </div>
        </>
    )
}
